
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Edit, Trash2 } from "lucide-react";

interface CommunityHelper {
  id: string;
  name: string;
  description: string;
  image_url: string;
  tools: string[];
  uniform: string;
  workplace: string;
  fun_fact: string;
  category_id: string | null;
  display_order: number;
  is_active: boolean;
  community_helper_categories?: { name: string };
}

interface CommunityHelperCategory {
  id: string;
  name: string;
  color: string;
  display_order: number;
  is_active: boolean;
}

interface HelpersTabProps {
  helpers: CommunityHelper[];
  categories: CommunityHelperCategory[];
  selectedCategoryFilter: string;
  onCategoryFilterChange: (value: string) => void;
  onAddHelper: () => void;
  onEditHelper: (helper: CommunityHelper) => void;
  onDeleteHelper: (helperId: string) => void;
}

const HelpersTab = ({
  helpers,
  categories,
  selectedCategoryFilter,
  onCategoryFilterChange,
  onAddHelper,
  onEditHelper,
  onDeleteHelper
}: HelpersTabProps) => {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Community Helpers</CardTitle>
        <div className="flex gap-4 items-center">
          <Select value={selectedCategoryFilter} onValueChange={onCategoryFilterChange}>
            <SelectTrigger className="w-48">
              <SelectValue placeholder="Filter by category" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Categories</SelectItem>
              {categories.map((category) => (
                <SelectItem key={category.id} value={category.id}>
                  {category.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <Button onClick={onAddHelper}>
            <Plus className="w-4 h-4 mr-2" />
            Add Helper
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Category</TableHead>
              <TableHead>Workplace</TableHead>
              <TableHead>Order</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {helpers.map((helper) => (
              <TableRow key={helper.id}>
                <TableCell>{helper.name}</TableCell>
                <TableCell>{helper.community_helper_categories?.name || "No Category"}</TableCell>
                <TableCell>{helper.workplace}</TableCell>
                <TableCell>{helper.display_order}</TableCell>
                <TableCell>
                  {helper.is_active ? "Active" : "Inactive"}
                </TableCell>
                <TableCell>
                  <div className="flex gap-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onEditHelper(helper)}
                    >
                      <Edit className="w-4 h-4" />
                    </Button>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onDeleteHelper(helper.id)}
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default HelpersTab;
